import { SearchInput } from 'react-admin';

const SearchFields = [
  <SearchInput source="q" alwaysOn color={'info'} sx={{ width: '100%' }} />,
];

export default SearchFields;
